export const MAX_YEAR_DIFF = 21;

export const FIELD_TYPE = {
  CARD_NUMBER: 'card-number',
  CARD_EXPIRATION_DATE: 'card-expiration-date',
  CARD_SECURITY_CODE: 'card-security-code',
  ZIP_CODE: 'zip-code',
  POSTAL_CODE: 'postal-code',
  FILE: 'file',
  SSN: 'ssn',
  CHECKBOX: 'checkbox',
  DROPDOWN: 'dropdown',
  PASSWORD: 'password',
  NUMBER: 'number',
  RADIO: 'radio',
  TEXTAREA: 'textarea',
  TEXT: 'text',
};

// card type mapped to the svg image name
export const cardIcons = {
  visa: 'visa',
  visaelectron: 'visa-electron',
  amex: 'amex',
  maestro: 'maestro',
  mastercard: 'mastercard',
  unionpay: 'unionpay',
  meeza: 'meeza',
  jcb: 'jcb',
  hipercard: 'hipercard',
  forbrugsforeningen: 'forbrugsforeningen',
  elo: 'elo',
  discover: 'discover',
  dinersclub: 'diners-club',
  dankort: 'dankort',
};

export const iconTypes = {
  cardNumber: 'card-icon',
  cardSecurityCode: 'cvv-icon',
};
